export function isExternal (path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

// 打开新页面
export function openNewTab(url) {
  const a = document.createElement('a')
  a.href = url
  a.target = '_blank'
  a.rel = 'noopener noreferrer' // 安全性
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a) // 清理
}
